'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createHOC;
var _object = require('object.assign');
var _object2 = _interopRequireDefault(_object);
var _hoistNonReactStatics = require('hoist-non-react-statics');
var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
var _propTypesExact = require('prop-types-exact');
var _propTypesExact2 = _interopRequireDefault(_propTypesExact);
var _getComponentName = require('airbnb-prop-types/build/helpers/getComponentName');
var _getComponentName2 = _interopRequireDefault(_getComponentName);
var _sloppy = require('prop-types-exact/build/sloppy');
var _sloppy2 = _interopRequireDefault(_sloppy);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
var getFactoryParamErrorMessage = function getFactoryParamErrorMessage(componentName) {
  return 'The `factory` option must be `true` or `false`.\n\nUse `factory: true` when you want a HOC factory function that takes params:\n\n' + String(componentName) + '(param1, param2)(WrappedComponent);\n\nUse `factory: false` when you want a HOC that takes params along with the wrapped component:\n\n' + String(componentName) + '(WrappedComponent, param1, param2);';
};
function createHOC(hocName, componentAndParamsToComponent, _ref) {
  var _ref$passedProps = _ref.passedProps,
    passedProps = _ref$passedProps === undefined ? [] : _ref$passedProps,
    factory = _ref.factory,
    _ref$allowExtraProps = _ref.allowExtraProps,
    allowExtraProps = _ref$allowExtraProps === undefined ? false : _ref$allowExtraProps;
  if (!hocName || typeof hocName !== 'string') {
    throw new Error('A valid name for this HOC must be passed.');
  }
  if (typeof componentAndParamsToComponent !== 'function') {
    throw new Error('A component wrapping function needs to be passed.');
  }
  if (componentAndParamsToComponent.length < 1) {
    throw new Error('The component wrapping function must take at least one parameter.');
  }
  if (typeof factory !== 'boolean') {
    throw new Error(getFactoryParamErrorMessage(hocName));
  }
  function hocFactory() {
    for (var _len = arguments.length, factoryParams = Array(_len), _key = 0; _key < _len; _key++) {
      factoryParams[_key] = arguments[_key];
    }
    return function () {
      function hoc(ComponentToWrap) {
        for (var _len2 = arguments.length, hocParams = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          hocParams[_key2 - 1] = arguments[_key2];
        }
        var NewComponent = componentAndParamsToComponent.apply(undefined, [ComponentToWrap].concat(_toConsumableArray(factory ? factoryParams : hocParams)));
        NewComponent.WrappedComponent = ComponentToWrap;
        NewComponent.displayName = String(hocName) + '(' + String((0, _getComponentName2['default'])(ComponentToWrap)) + ')';
        if (ComponentToWrap.propTypes) {
          var copiedProps = (0, _object2['default'])({}, (0, _sloppy2['default'])(ComponentToWrap.propTypes));
          passedProps.forEach(function (propName) {
            delete copiedProps[propName];
          });
          var newPropTypes = (0, _object2['default'])({}, copiedProps, NewComponent.propTypes && (0, _sloppy2['default'])(NewComponent.propTypes));
          if (allowExtraProps) {
            NewComponent.propTypes = newPropTypes;
          } else {
            NewComponent.propTypes = (0, _propTypesExact2['default'])(newPropTypes);
          }
        } else if (!allowExtraProps) {
          // Get "sloppy" propTypes before getting "exact" prop types in case
          // the original prop types were already "exact"
          NewComponent.propTypes = (0, _propTypesExact2['default'])((0, _sloppy2['default'])(NewComponent.propTypes));
        }
        return (0, _hoistNonReactStatics2['default'])(NewComponent, ComponentToWrap);
      }
      return hoc;
    }();
  }
  if (factory) {
    return hocFactory;
  }
  return hocFactory();
}